import React from 'react';
import classNames from 'classnames';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';

import { useParams } from 'react-router-dom';
import useGetLibraryNewsItem from '../../hooks/useGetLibraryNewsItem/useGetLibraryNewsItem';
import useSetPageTitle from '../../hooks/useSetPageTitle/useSetPageTitle';

import PageBanner from '../../common/PageBanner/PageBanner';
import Spinner from '../../components/Spinner/Spinner';

import placeholderImage from '../../images/placeholder.jpg';

import styles from './LibraryNewsPage.module.scss';
import commons from '../../shared/styles/common.module.scss';

const LibraryNewsPage = () => {
  const { t } = useTranslation();
  const params = useParams();
  const postId = params.libraryNewsId;

  const { data, refetch } = useGetLibraryNewsItem(Number(postId), false);

  useSetPageTitle({
    pageTitle: `${data?.title} - ${t('general.website-name')}`,
  });

  React.useEffect(() => {
    if (postId) {
      refetch();
    }
  }, [postId, refetch]);

  return !data ? (
    <Spinner variant='green' />
  ) : (
    <div>
      <PageBanner
        title={data.title}
        imageSrc={data.featured_image || placeholderImage}
        imageText={data.title}
      />
      <div className={classNames(styles.libraryContainer, commons.container)}>
        <div>
          <h1
            className={classNames(
              styles.libraryTitle,
              commons.subSectionHeading,
            )}>
            {data.title}
          </h1>
          <div className={styles.libraryContent}>{parse(data.content)}</div>
          {data.featured_image && (
            <img
              src={data.featured_image}
              alt={data.title}
              className={styles.libraryContentImage}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default LibraryNewsPage;
